import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gdo-payment',
    templateUrl: './gdo-payment.component.html',
    styleUrls: ['./gdo-payment.component.scss'],
    standalone: false
})
export class GdoPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
